import { motion } from 'framer-motion';
import styled from 'styled-components';

export const ResourcesNLPSearchWrapper = styled(motion.div).attrs({
  layoutId: 'resources-nlp-search-wrapper',
  layout: true,
})`
  width: 100%;
  display: flex;
  flex-direction: column;

  border-radius: 8px;
  background: ${({ theme }) => (!theme.isLoading ? '#ffffff' : 'none')};
  box-shadow: 5px 0px 20px -10px rgba(50, 63, 93, 0.1);
  align-self: center;
  z-index: 99;
`;
